"use client";

import { SoundProvider } from "@/lib/state/sound-context";
import { AuthProvider } from "@/lib/state/auth-context";
import { SWRProvider } from "@/lib/state/swr-provider";
import { MapProvider } from "@/lib/state/map-context";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SoundProvider>
      <AuthProvider>
        <SWRProvider>
          <MapProvider>{children}</MapProvider>
        </SWRProvider>
      </AuthProvider>
    </SoundProvider>
  );
}
